import { Box, TableCell, TableRow, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useState } from "react";
import TableActions from "src/common/TableActions";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import { useApiMutation } from "src/hooks/useApiMutation";
import type { IB2BMoneyReceiptList } from "../type/b2bType";

type IProps = {
	serial: number;
	paginationSkip: number;
	moneyReceipt: IB2BMoneyReceiptList;
};

const B2BMoneyReceiptTableRow = ({
	serial,
	paginationSkip,
	moneyReceipt,
}: IProps) => {
	const [open, setOpen] = useState(false);
	const handleClose = () => setOpen(false);
	const {
		mutate: deleteMoneyReceipt,
		isPending,
		isSuccess,
	} = useApiMutation<void, void>({
		method: "DELETE",
		endPoint: `/api/admin/b2b/money-receipt/${moneyReceipt.id}`,
		invalidateQueries: ["b2b-money-receipt"],
	});
	return (
		<>
			<TableRow hover>
				<TableCell>{serial + Number(paginationSkip)}</TableCell>
				<TableCell>
					<Typography variant='body1' color='text.primary' noWrap>
						{dayjs(moneyReceipt.payment_date).format("DD-MM-YYYY")}
					</Typography>
				</TableCell>
				<TableCell>{moneyReceipt.money_receipt_no}</TableCell>
				<TableCell>
					<Box sx={{ display: "flex", flexDirection: "column", gap: 0.25 }}>
						{moneyReceipt.b2b_name ? (
							<Typography
								variant='body2'
								fontWeight={600}
								color='text.primary'
								sx={{ fontSize: "0.85rem", lineHeight: 1.25 }}
							>
								{moneyReceipt.b2b_organization}
							</Typography>
						) : (
							<Typography variant='body2' color='text.secondary'>
								N/A
							</Typography>
						)}
						{moneyReceipt.b2b_email && (
							<Typography
								variant='body1'
								color='text.secondary'
								sx={{ fontSize: "0.75rem", lineHeight: 1.2, wordBreak: "break-word" }}
							>
								{moneyReceipt.b2b_email}
							</Typography>
						)}
						{moneyReceipt.b2b_phone && (
							<Typography
								variant='caption'
								color='text.secondary'
								sx={{ fontSize: "0.75rem", lineHeight: 1.2 }}
							>
								{moneyReceipt.b2b_phone}
							</Typography>
						)}
					</Box>
				</TableCell>
				<TableCell>{moneyReceipt.payment_method || "N/A"}</TableCell>
				<TableCell>
					{parseFloat(moneyReceipt.paid_amount)?.toFixed(2)}
				</TableCell>

				<TableActions
					showView
					viewLink={`/b2b/money-receipt/details/${moneyReceipt.id}`}
					showDelete
					handleDeleteFun={() => deleteMoneyReceipt()}
				/>
			</TableRow>

			<ModalsWrapper
				showModal={open}
				setShowModal={setOpen}
				modalData={{ title: "Update Money Receipt" }}
			>
				<>
					{/* <EditMoneyReceipt
                        id={moneyReceipt.id}
                        handleClose={handleClose}
                    /> */}
				</>
			</ModalsWrapper>
		</>
	);
};

export default B2BMoneyReceiptTableRow;
